var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompleteStepGreenMobile = function SvgCompleteStepGreenMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "stepper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Step Counter",
    transform: "translate(3.951 -.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-3.951 .049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.033 12.378a1.114 1.114 0 0 0-1.617 0l-8.482 8.758-3.563-3.686a1.139 1.139 0 0 0-1.645.029 1.226 1.226 0 0 0 .028 1.7l4.367 4.505a1.114 1.114 0 0 0 1.617 0l9.29-9.58a1.2 1.2 0 0 0 0-1.726Z",
    "data-fill": "a"
  }))));
};
export default SvgCompleteStepGreenMobile;